export const FETCH = 'RECOMMENDATIONS_BENCHMARKS/FETCH'
export const TOGGLE_ARCHIVE = 'RECOMMENDATIONS_BENCHMARKS/TOGGLE_ARCHIVE'
export const SETUP_FILTERS = 'RECOMMENDATIONS_BENCHMARKS/SETUP_FILTERS'

export const FETCH_NOTIFICATIONS = 'RECOMMENDATIONS_BENCHMARKS/FETCH_NOTIFICATIONS'

export const QUERY_TYPE = 'RECOMMENDATIONS_BENCHMARKS/QUERY_TYPE'

export const SET_BENCHMARKS = 'RECOMMENDATIONS_BENCHMARKS/SET_BENCHMARKS'

export const UPDATE = 'RECOMMENDATIONS_BENCHMARKS/UPDATE'

export const SET_ARCHIVE_PROCESSING_IDS = 'RECOMMENDATIONS_BENCHMARKS/SET_ARCHIVE_PROCESSING_IDS'

export const REMOVE_FROM_LIST = 'RECOMMENDATIONS_BENCHMARKS/REMOVE_FROM_LIST'

export const SET_FILTER = 'RECOMMENDATIONS_BENCHMARKS/SET_FILTER'

export const SET_FILTERS = 'RECOMMENDATIONS_BENCHMARKS/SET_FILTERS'

export const SET_NOTIFICATIONS = 'RECOMMENDATIONS_BENCHMARKS/SET_NOTIFICATIONS'

export const DROP_LIST = 'RECOMMENDATIONS_BENCHMARKS/DROP_LIST'

export const SEEN = 'RECOMMENDATIONS_BENCHMARKS/SEEN'
